module.exports = __webpack_public_path__ + "img/回家过年.3e21d0e1.png";